import * as React from 'react';

function useHistoryBack(callback, enabled) {
    React.useEffect(function () {
        if (!enabled) {
            return;
        }
        // Push a fake state so it doesn't go back.
        window.history.pushState({ fakeHistoryItem: true, options: { shallow: true } }, "");
        window.addEventListener("popstate", callback);
        return function () {
            window.removeEventListener("popstate", callback);
            // If capturing is disabled without going back, remove fake state.
            if (window.history.state && window.history.state.fakeHistoryItem) {
                window.history.back();
            }
        };
    }, [enabled]);
}

export { useHistoryBack as u };
//# sourceMappingURL=useHistoryBack-a0e15180.js.map
